export default API => ({
  // 我的订单详情
  myOrderDetail(id) {
    return API({
      url: `/order/v1/open/order/myOrderDetail?id=${id}`,
      method: 'get',
    });
  },
  // 实物商品申请退款详情
  getEntityGoodOrderDetail(params) {
    return API({ 
        url: `/order/v1/open/order/getOrderByNo`,
        params
    });
  },
  // 申请退款
  refundSave(data) {
    return API({
      url: `/order/v1/refund/save`,
      method: 'post',
      data
    });
  },
  // 图片上传到服务器
  upload(data) {
    return API({
      url: '/resource/v1/resource/uploadImage',
      method: 'post',
      data
    })
  },
  // 前台退款记录
  refundProcess(params){
    return API({
      url: '/order/v1/refund/refundProcess',
      method: 'get',
      params
    })
  },
  // 学员 快递信息提交
  postInfoSubmit(data){
    return API({
      url: '/order/v1/refund/postInfoSubmit',
      method: 'post',
      data
    })
  },
  //获取快递公司列表
  findExpressCompanyList() {
    return API({
        url: `/order/v1/admin/expressCompany/findList`,
        method:  'get'
    });
},

})
